import './Modal.scss'

import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { addBodyClass, removeBodyClass } from '../../helpers/dom'

import classNames from 'classnames'

const Modal = ({ dialog, onCloseRequested, children, elementRef }) => {
  const modal = useRef()
  const timer = useRef(false)
  const [closing, setClosing] = useState(false)

  const delayedClosing = useCallback((success) => {
    setClosing(true)
    timer.current = setTimeout(() => {
      onCloseRequested(success)
    }, 500)
  }, [onCloseRequested])

  const handleClose = useCallback(() => delayedClosing(false), [delayedClosing])

  useLayoutEffect(() => {
    const eventListener = (event) => {
      event.stopPropagation()
      if (event.detail.action === 'CLOSE' && !timer.current) {
        delayedClosing(event.detail.success)
      }
    }
    const element = modal.current
    element.addEventListener('ModalEvent', eventListener, false)
    return () => {
      element.removeEventListener('ModalEvent', eventListener, false)
    }
  }, [modal, delayedClosing])

  useLayoutEffect(() => {
    if (elementRef) elementRef.current = modal.current
  }, [elementRef])

  useEffect(() => {
    addBodyClass('modal-body-no-scroll')
    return () => {
      removeBodyClass('modal-body-no-scroll')
    }
  }, [])

  return (
    <div ref={modal} className={classNames('modal', { '-close': closing, '-dialog': dialog })}>
      <div className='-overlay' onClick={handleClose}></div>
      <div className='-content'>{children}</div>
    </div>
  )
}

export default Modal
